import { Roles } from './enums/roles.enum';
import { MY_GEM_FAV_ROUTE, MY_GEM_VAULT_ROUTE, POROLIS_GEM_BANK_ROUTE } from './routes';
import { NavbarOptions } from './enums/navbar-option.enum';
import MyGemVaultSvg from '../assets/img/my-gem-vault.svg';
import MyGemFavSvg from '../assets/img/folder-favourite.svg';
import MyGemFavSvgBold from '../assets/img/folder-favourite-bold.svg';
import PorolisGemBankSvg from '../assets/img/bank.svg';
import PorolisGemBankSvgBold from '../assets/img/bank-bold.svg';
import MyGemVaultBoldSvg from '../assets/img/my-gem-vault-selected.svg';

export const NAVBAR_OPTIONS = {
  [NavbarOptions.MY_GEM_VAULT]: {
    name: NavbarOptions.MY_GEM_VAULT,
    path: MY_GEM_VAULT_ROUTE,
    icon: { selected: MyGemVaultBoldSvg, unselected: MyGemVaultSvg },
    roles: [Roles.SAAS_USER, Roles.SAAS_ADMIN, Roles.NCC_USER],
  },
  [NavbarOptions.MY_GEM_FAV]: {
    name: NavbarOptions.MY_GEM_FAV,
    path: MY_GEM_FAV_ROUTE,
    icon: { selected: MyGemFavSvgBold, unselected: MyGemFavSvg },
    roles: [Roles.SAAS_USER, Roles.SAAS_ADMIN, Roles.NCC_USER],
  },
  [NavbarOptions.POROLIS_GEM_BANK]: {
    name: NavbarOptions.POROLIS_GEM_BANK,
    path: POROLIS_GEM_BANK_ROUTE,
    icon: { selected: PorolisGemBankSvgBold, unselected: PorolisGemBankSvg },
    roles: [Roles.SAAS_ADMIN, Roles.SAAS_USER, Roles.NCC_USER],
  },
};
